export default {
  shareSubmission: function (item, emails) {
    let request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: item.coursework_entry_share_path,
      data: {
        emails: emails
      }
    });

    request.done(function (res) {
      new Kadenze.Notice.success(res);
    });

    request.fail(function (xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
      }
      new Kadenze.Notice.error({message: msg});
    });
  }
};

